export enum RewardAmountType {
  Fixed = 'fixed',
  Percent = 'percent',
  Count = 'count',
}
